import { Popup } from '@approvalmax/ui/src/components';
import { domain } from 'modules/data';
import { useSelector } from 'modules/react-redux';
import { memo } from 'react';
import { useGetXeroRequestsDuplicates } from 'shared/data/webApp/v2';

import { getRequest } from '../../../../selectors/pageSelectors';
import { getXeroLineItemsSummary } from '../../../../selectors/xero';
import { useDuplicatesPopup } from '../../CheckDuplicatesPopup.hooks';
import { PopupContent } from '../PopupContent/PopupContent';
import { XeroPopupProps } from './XeroPopup.types';

export const XeroPopup = memo<XeroPopupProps>((props) => {
    const { onCancel, onSubmit } = props;

    const request = useSelector<domain.XeroBillRequest>(getRequest);
    const summary = useSelector((state) => getXeroLineItemsSummary(state, request));

    const getDuplicates = useGetXeroRequestsDuplicates({
        path: {
            companyId: request.companyId,
        },
        query: {
            amount: summary.totalAmount,
            counterPartyId: request.details.contact?.id,
            currency: request.currency,
            date: request.details.date,
            integrationCode: request.integrationCode,
            invoiceNumber: request.details.reference,
        },
    });

    const { isOpen, toggleIsOpen, currentDuplicates, handleSubmit, handleCancel } = useDuplicatesPopup({
        onCancel,
        onSubmit,
        ...getDuplicates,
    });

    return (
        <Popup open={isOpen} onToggle={toggleIsOpen} onClose={handleCancel}>
            <PopupContent duplicates={currentDuplicates} onCancel={handleCancel} onSubmit={handleSubmit} />
        </Popup>
    );
});

XeroPopup.displayName = 'XeroPopup';
